// FastNavigator.js

import React, { useState } from "react";
import "../../scss/layout/footer.scss";
import {
  Business,
  Language,
  Build,
  Info,
  Work,
  NewReleases,
  Flight,
  DirectionsBoat,
  LocalShipping,
  Train,
  Inventory,
  Handshake,
} from "@mui/icons-material";
import truck from "../../images/aeroplane.jpg";
import port1 from "../../images/port1.jpg";
import port2 from "../../images/port2.jpg";
import First from "../../images/first1.jpg";
import YourFormComponent from "../base/modalform";
import BusinessForm from "../base/modalbuisness";
import Slidermodal from "../base/slidermodal";
import { NavLink } from "react-router-dom";

const logisticsOptions = [
  { icon: <Flight />, label: "AIR" },
  { icon: <DirectionsBoat />, label: "SEA" },
  { icon: <LocalShipping />, label: "ROAD" },
  { icon: <Train />, label: "RAIL" },
  { icon: <Inventory />, label: "CONTRACT-LOGISTICS" },
  { icon: <Handshake />, label: "OTHER-SERVICES" },
];

const FastNavigator = ({ setHoveredImage }) => {
  const [showBusinessOptions, setShowBusinessOptions] = useState(false);
  const [modalStages, setModalStages] = useState({});
  const [showTrackTraceModal, setShowTrackTraceModal] = useState(false);
  const [showServiceModal, setShowServiceModal] = useState(false);
  const [showKnowModal, setShowKnowModal] = useState(false);
  const openBusinessModal = (type) => {
    setShowBusinessOptions(true);
    setModalStages({ [type]: 1 });
  };

  const updateModalStage = (type, stage) => {
    setModalStages((prev) => ({ ...prev, [type]: stage }));
  };

  const closeAllModals = () => {
    setModalStages({});
    setShowBusinessOptions(false);
  };

  return (
    <div className={`fast-navigator ${showBusinessOptions ? "blurred" : ""}`}>
      <div className="fast-navigator__title">
        <h4>FAST NAVIGATOR</h4>
      </div>

      <div className="fast-navigator__icons">
        <div
          className="icon-item"
          onMouseEnter={() =>
            setHoveredImage({ src: truck, heading: "Let's Do Business" })
          }
          onClick={() => openBusinessModal("GENERAL")}
        >
          <Business className="icon" />
          <p>LET'S DO BUSINESS</p>
        </div>

        <div
          className="icon-item"
          onMouseEnter={() =>
            setHoveredImage({ src: port1, heading: "Track & Trace" })
          }
          onClick={() => setShowTrackTraceModal(true)}
        >
          <Language className="icon" />
          <p>TRACK & TRACE</p>
        </div>

        <div
          className="icon-item"
          onMouseEnter={() =>
            setHoveredImage({ src: port2, heading: "Our Services" })
          }
          onClick={() => setShowServiceModal(true)}
        >
          <Build className="icon" />
          <p>SERVICES</p>
        </div>

        {showServiceModal && (
          <Slidermodal setShowServiceModal={setShowServiceModal} />
        )}

        <div
          className="icon-item"
          onMouseEnter={() =>
            setHoveredImage({ src: First, heading: "GET TO KNOW US" })
          }
          onClick={() => setShowKnowModal(true)}
        >
          <Info className="icon" />
          <p>GET TO KNOW US</p>
        </div>

        <div className="icon-item">
          <Work className="icon" />
          <p>FIND YOUR JOB</p>
        </div>

        <div className="icon-item highlight">
          <NewReleases className="icon" />
          <p>WHAT'S NEW?</p>
        </div>
      </div>

      <div className="fast-navigator__footer">
        <p>WHISTLEBLOWING</p>
        <p>LEGAL</p>
        <p>PRIVACY</p>
        <p>COOKIES</p>
      </div>

      {/* Business Modal Menu */}
      {showBusinessOptions && modalStages["GENERAL"] === 1 && (
        <div className="business-modal">
          <div className="modal-content">
            <h2>Let's Do Business!</h2>
            <p>YOUR LOGISTICS NEEDS</p>

            <div className="business-options">
              {logisticsOptions.map((option) => (
                <div
                  key={option.label}
                  className="business-option"
                  onClick={() => openBusinessModal(option.label)}
                >
                  {option.icon} {option.label}
                </div>
              ))}
            </div>

            <button className="close-modal" onClick={closeAllModals}>
              ✖
            </button>
          </div>
        </div>
      )}

      {/* AIR Modal with Full Sequence */}
      {modalStages["AIR"] && (
        <div className="business-modal">
          <div className="modal-content">
            {modalStages["AIR"] === 1 && (
              <>
                <h2>Let's do Business - AIR!</h2>
                <p>YOUR ANNUAL TRANSPORT VOLUME?</p>
                <select className="transport-volume">
                  <option value="<5t">{"< 5t"}</option>
                  <option value="5-10t">5-10t</option>
                  <option value="10-20t">10-20t</option>
                  <option value=">20t">{"> 20t"}</option>
                </select>
                <div className="modal-buttons">
                  <button className="back" onClick={closeAllModals}>
                    BACK
                  </button>
                  <button
                    className="next-step"
                    onClick={() => updateModalStage("AIR", 2)}
                  >
                    NEXT STEP
                  </button>
                </div>
              </>
            )}
            {modalStages["AIR"] === 2 && (
              <>
                <h2>Let's do Business - AIR!</h2>
                <textarea
                  style={{
                    width: "100%",
                    height: "80px",
                    backgroundColor: "transparent",
                    color: "white",
                    border: "2px solid white",
                    borderRadius: "5px",
                    backdropFilter: "blur(20px)",
                    padding: "10px",
                  }}
                  placeholder="YOUR MESSAGE"
                  maxLength={2000}
                ></textarea>
                <p>Please enter your message.</p>
                <span>0/2000</span>
                <div className="modal-buttons">
                  <button
                    className="back"
                    onClick={() => updateModalStage("AIR", 1)}
                  >
                    BACK
                  </button>
                  <button
                    className="next-step"
                    onClick={() => updateModalStage("AIR", 3)}
                  >
                    NEXT STEP
                  </button>
                </div>
              </>
            )}
            {modalStages["AIR"] === 3 && (
              <>
                <YourFormComponent />
                <div className="modal-buttons">
                  <button
                    className="back"
                    onClick={() => updateModalStage("AIR", 2)}
                  >
                    BACK
                  </button>
                  <button
                    className="next-step"
                    onClick={() => updateModalStage("AIR", 4)}
                  >
                    NEXT STEP
                  </button>
                </div>
              </>
            )}
            {modalStages["AIR"] === 4 && (
              <>
                <BusinessForm />
                <div className="modal-buttons">
                  <button
                    className="back"
                    onClick={() => updateModalStage("AIR", 3)}
                  >
                    BACK
                  </button>
                  <button className="next-step">SUBMIT</button>
                </div>
              </>
            )}
            <button
              className="close-modal"
              onClick={() => updateModalStage("AIR", 0)}
            >
              ✖
            </button>
          </div>
        </div>
      )}

      {/* SEA Modal Placeholder */}
      {modalStages["SEA"] && (
        <div className="business-modal">
          <div className="modal-content">
            {modalStages["SEA"] === 1 && (
              <>
                <h2>Let's do Business - SEA!</h2>
                <p>YOUR ANNUAL TRANSPORT VOLUME?</p>
                <select className="transport-volume">
                  <option value="FCL">{"FCL"}</option>
                  <option value="LCL">LCL</option>
                </select>
                <select className="transport-volume1">
                  <option value="<24 TEU">{" >24 TEU"}</option>
                  <option value="25-99 TEU">25-99 TEU</option>
                  <option value="100-499 TEU">100-499 TEU</option>
                  <option value=">500 TEU">{"> 500 TEU"}</option>
                </select>
                <div className="modal-buttons">
                  <button className="back" onClick={closeAllModals}>
                    BACK
                  </button>
                  <button
                    className="next-step"
                    onClick={() => updateModalStage("SEA", 2)}
                  >
                    NEXT STEP
                  </button>
                </div>
              </>
            )}
            {modalStages["SEA"] === 2 && (
              <>
                <h2>Let's do Business - SEA!</h2>
                <textarea
                  style={{
                    width: "100%",
                    height: "80px",
                    backgroundColor: "transparent",
                    color: "white",
                    border: "2px solid white",
                    borderRadius: "5px",
                    backdropFilter: "blur(20px)",
                    padding: "10px",
                  }}
                  placeholder="YOUR MESSAGE"
                  maxLength={2000}
                ></textarea>
                <p>Please enter your message.</p>
                <span>0/2000</span>
                <div className="modal-buttons">
                  <button
                    className="back"
                    onClick={() => updateModalStage("SEA", 1)}
                  >
                    BACK
                  </button>
                  <button
                    className="next-step"
                    onClick={() => updateModalStage("SEA", 3)}
                  >
                    NEXT STEP
                  </button>
                </div>
              </>
            )}
            {modalStages["SEA"] === 3 && (
              <>
                <YourFormComponent />
                <div className="modal-buttons">
                  <button
                    className="back"
                    onClick={() => updateModalStage("SEA", 2)}
                  >
                    BACK
                  </button>
                  <button
                    className="next-step"
                    onClick={() => updateModalStage("SEA", 4)}
                  >
                    NEXT STEP
                  </button>
                </div>
              </>
            )}
            {modalStages["SEA"] === 4 && (
              <>
                <BusinessForm />
                <div className="modal-buttons">
                  <button
                    className="back"
                    onClick={() => updateModalStage("SEA", 3)}
                  >
                    BACK
                  </button>
                  <button className="next-step">SUBMIT</button>
                </div>
              </>
            )}
          </div>
        </div>
      )}
      {modalStages["ROAD"] && (
        <div className="business-modal">
          <div className="modal-content">
            {modalStages["ROAD"] === 1 && (
              <>
                <h2>Let's do Business - ROAD!</h2>
                <p>YOUR ANNUAL TRANSPORT VOLUME?</p>
                <select className="transport-volume">
                  <option value="CEP">{"CEP"}</option>
                  <option value="GROUPAGE">GROUPAGE</option>
                  <option value="FTL/LTL">FTL/LTL</option>
                </select>
                <select className="transport-volume1">
                  <option value="1-200">{"1-200"}</option>
                  <option value="200-1000">200-1000</option>
                  <option value="100-499 TEU">100-499 TEU</option>
                  <option value=">1000">{">1000"}</option>
                </select>
                <div className="modal-buttons">
                  <button className="back" onClick={closeAllModals}>
                    BACK
                  </button>
                  <button
                    className="next-step"
                    onClick={() => updateModalStage("ROAD", 2)}
                  >
                    NEXT STEP
                  </button>
                </div>
              </>
            )}
            {modalStages["ROAD"] === 2 && (
              <>
                <h2>Let's do Business - SEA!</h2>
                <textarea
                  style={{
                    width: "100%",
                    height: "80px",
                    backgroundColor: "transparent",
                    color: "white",
                    border: "2px solid white",
                    borderRadius: "5px",
                    backdropFilter: "blur(20px)",
                    padding: "10px",
                  }}
                  placeholder="YOUR MESSAGE"
                  maxLength={2000}
                ></textarea>
                <p>Please enter your message.</p>
                <span>0/2000</span>
                <div className="modal-buttons">
                  <button
                    className="back"
                    onClick={() => updateModalStage("ROAD", 1)}
                  >
                    BACK
                  </button>
                  <button
                    className="next-step"
                    onClick={() => updateModalStage("ROAD", 3)}
                  >
                    NEXT STEP
                  </button>
                </div>
              </>
            )}
            {modalStages["ROAD"] === 3 && (
              <>
                <YourFormComponent />
                <div className="modal-buttons">
                  <button
                    className="back"
                    onClick={() => updateModalStage("ROAD", 2)}
                  >
                    BACK
                  </button>
                  <button
                    className="next-step"
                    onClick={() => updateModalStage("ROAD", 4)}
                  >
                    NEXT STEP
                  </button>
                </div>
              </>
            )}
            {modalStages["ROAD"] === 4 && (
              <>
                <BusinessForm />
                <div className="modal-buttons">
                  <button
                    className="back"
                    onClick={() => updateModalStage("ROAD", 3)}
                  >
                    BACK
                  </button>
                  <button className="next-step">SUBMIT</button>
                </div>
              </>
            )}
          </div>
        </div>
      )}
      {modalStages["RAIL"] && (
        <div className="business-modal">
          <div className="modal-content">
            {modalStages["RAIL"] === 1 && (
              <>
                <h2>Let's do Business - RAIL!</h2>
                <p>YOUR ANNUAL TRANSPORT VOLUME?</p>
                <select className="transport-volume1">
                  <option value="<24 TEU">{" >24 TEU"}</option>
                  <option value="25-99 TEU">25-99 TEU</option>
                  <option value="100-499 TEU">100-499 TEU</option>
                  <option value=">500 TEU">{"> 500 TEU"}</option>
                </select>
                <div className="modal-buttons">
                  <button className="back" onClick={closeAllModals}>
                    BACK
                  </button>
                  <button
                    className="next-step"
                    onClick={() => updateModalStage("RAIL", 2)}
                  >
                    NEXT STEP
                  </button>
                </div>
              </>
            )}
            {modalStages["RAIL"] === 2 && (
              <>
                <h2>Let's do Business - RAIL!</h2>
                <textarea
                  style={{
                    width: "100%",
                    height: "80px",
                    backgroundColor: "transparent",
                    color: "white",
                    border: "2px solid white",
                    borderRadius: "5px",
                    backdropFilter: "blur(20px)",
                    padding: "10px",
                  }}
                  placeholder="YOUR MESSAGE"
                  maxLength={2000}
                ></textarea>
                <p>Please enter your message.</p>
                <span>0/2000</span>
                <div className="modal-buttons">
                  <button
                    className="back"
                    onClick={() => updateModalStage("RAIL", 1)}
                  >
                    BACK
                  </button>
                  <button
                    className="next-step"
                    onClick={() => updateModalStage("RAIL", 3)}
                  >
                    NEXT STEP
                  </button>
                </div>
              </>
            )}
            {modalStages["RAIL"] === 3 && (
              <>
                <YourFormComponent />
                <div className="modal-buttons">
                  <button
                    className="back"
                    onClick={() => updateModalStage("RAIL", 2)}
                  >
                    BACK
                  </button>
                  <button
                    className="next-step"
                    onClick={() => updateModalStage("RAIL", 4)}
                  >
                    NEXT STEP
                  </button>
                </div>
              </>
            )}
            {modalStages["RAIL"] === 4 && (
              <>
                <BusinessForm />
                <div className="modal-buttons">
                  <button
                    className="back"
                    onClick={() => updateModalStage("RAIL", 3)}
                  >
                    BACK
                  </button>
                  <button className="next-step">SUBMIT</button>
                </div>
              </>
            )}
          </div>
        </div>
      )}
      {modalStages["CONTRACT-LOGISTICS"] && (
        <div className="business-modal">
          <div className="modal-content">
            {modalStages["CONTRACT-LOGISTICS"] === 1 && (
              <>
                <h2>Let's do Business - CONTRACT LOGISTICS!</h2>
                <p>Your annual warehouse space?</p>
                <select className="transport-volume1">
                  <option value="<1000 m²">{" <1000 m²"}</option>
                  <option value=">1000 m² "> {">1000 m²"}</option>
                </select>
                <div className="modal-buttons">
                  <button className="back" onClick={closeAllModals}>
                    BACK
                  </button>
                  <button
                    className="next-step"
                    onClick={() => updateModalStage("CONTRACT-LOGISTICS", 2)}
                  >
                    NEXT STEP
                  </button>
                </div>
              </>
            )}
            {modalStages["CONTRACT-LOGISTICS"] === 2 && (
              <>
                <h2>Let's do Business - CONTRACT LOGISTICS!</h2>
                <textarea
                  style={{
                    width: "100%",
                    height: "80px",
                    backgroundColor: "transparent",
                    color: "white",
                    border: "2px solid white",
                    borderRadius: "5px",
                    backdropFilter: "blur(20px)",
                    padding: "10px",
                  }}
                  placeholder="YOUR MESSAGE"
                  maxLength={2000}
                ></textarea>
                <p>Please enter your message.</p>
                <span>0/2000</span>
                <div className="modal-buttons">
                  <button
                    className="back"
                    onClick={() => updateModalStage("CONTRACT-LOGISTICS", 1)}
                  >
                    BACK
                  </button>
                  <button
                    className="next-step"
                    onClick={() => updateModalStage("CONTRACT-LOGISTICS", 3)}
                  >
                    NEXT STEP
                  </button>
                </div>
              </>
            )}
            {modalStages["CONTRACT-LOGISTICS"] === 3 && (
              <>
                <YourFormComponent />
                <div className="modal-buttons">
                  <button
                    className="back"
                    onClick={() => updateModalStage("CONTRACT-LOGISTICS", 2)}
                  >
                    BACK
                  </button>
                  <button
                    className="next-step"
                    onClick={() => updateModalStage("CONTRACT-LOGISTICS", 4)}
                  >
                    NEXT STEP
                  </button>
                </div>
              </>
            )}
            {modalStages["CONTRACT-LOGISTICS"] === 4 && (
              <>
                <BusinessForm />
                <div className="modal-buttons">
                  <button
                    className="back"
                    onClick={() => updateModalStage("CONTRACT-LOGISTICS", 3)}
                  >
                    BACK
                  </button>
                  <button className="next-step">SUBMIT</button>
                </div>
              </>
            )}
          </div>
        </div>
      )}
      {modalStages["OTHER-SERVICES"] && (
        <div className="business-modal">
          <div className="modal-content">
            {modalStages["OTHER-SERVICES"] === 1 && (
              <>
                <h2>Let's do Business - OTHER SERVICES</h2>
                <p>Your annual warehouse space?</p>
                <select className="transport-volume1">
                  <option value="<E-Commerce">{" <E-Commerce"}</option>
                  <option value=">Smart Tracking "> {">Smart Tracking"}</option>
                  <option value=">Customs Brokerage ">
                    {" "}
                    {">Customs Brokerage"}
                  </option>
                  <option value=">Oversized Cargo ">
                    {" "}
                    {">Oversized Cargo"}
                  </option>
                  <option value=">Warehousing "> {">Warehousing"}</option>
                  <option value=">Others "> {">Others"}</option>
                </select>
                <textarea
                  style={{
                    width: "100%",
                    height: "80px",
                    backgroundColor: "transparent",
                    color: "white",
                    border: "2px solid white",
                    borderRadius: "5px",
                    backdropFilter: "blur(20px)",
                    padding: "10px",
                  }}
                  placeholder="YOUR MESSAGE"
                  maxLength={2000}
                ></textarea>
                <p>Please enter your message.</p>
                <span>0/2000</span>
                <div className="modal-buttons">
                  <button className="back" onClick={closeAllModals}>
                    BACK
                  </button>
                  <button
                    className="next-step"
                    onClick={() => updateModalStage("OTHER-SERVICES", 2)}
                  >
                    NEXT STEP
                  </button>
                </div>
              </>
            )}
            {modalStages["OTHER-SERVICES"] === 2 && (
              <>
                <h2>Let's do Business - OTHER SERVICES!</h2>
                <textarea
                  style={{
                    width: "100%",
                    height: "80px",
                    backgroundColor: "transparent",
                    color: "white",
                    border: "2px solid white",
                    borderRadius: "5px",
                    backdropFilter: "blur(20px)",
                    padding: "10px",
                  }}
                  placeholder="YOUR MESSAGE"
                  maxLength={2000}
                ></textarea>
                <p>Please enter your message.</p>
                <span>0/2000</span>
                <div className="modal-buttons">
                  <button
                    className="back"
                    onClick={() => updateModalStage("OTHER-SERVICES", 1)}
                  >
                    BACK
                  </button>
                  <button
                    className="next-step"
                    onClick={() => updateModalStage("OTHER-SERVICES", 3)}
                  >
                    NEXT STEP
                  </button>
                </div>
              </>
            )}
            {modalStages["OTHER-SERVICES"] === 3 && (
              <>
                <YourFormComponent />
                <div className="modal-buttons">
                  <button
                    className="back"
                    onClick={() => updateModalStage("OTHER-SERVICES", 2)}
                  >
                    BACK
                  </button>
                  <button
                    className="next-step"
                    onClick={() => updateModalStage("OTHER-SERVICES", 4)}
                  >
                    NEXT STEP
                  </button>
                </div>
              </>
            )}
            {modalStages["OTHER-SERVICES"] === 4 && (
              <>
                <BusinessForm />
                <div className="modal-buttons">
                  <button
                    className="back"
                    onClick={() => updateModalStage("OTHER-SERVICES", 3)}
                  >
                    BACK
                  </button>
                  <button className="next-step">SUBMIT</button>
                </div>
              </>
            )}
          </div>
        </div>
      )}

      {/* Track & Trace Modal */}
      {showTrackTraceModal && (
        <div className="business-modal">
          <div className="modal-content">
            <h2>Track & Trace</h2>
            <p>Enter your tracking number below:</p>
            <input
              type="text"
              placeholder="Tracking Number"
              style={{
                width: "18%",
                height: "50px",
                backgroundColor: "transparent",
                color: "white",
                border: "2px solid white",
                borderRadius: "5px",
                backdropFilter: "blur(20px)",
                padding: "10px",
              }}
            />
            <button className="back">Track</button>
            <button
              className="close-modal"
              onClick={() => setShowTrackTraceModal(false)}
            >
              ✖
            </button>
          </div>
        </div>
      )}

      {/* Know Modal */}
      {showKnowModal && (
        <div className="business-modal">
          <div className="modal-content">
            <h1
              style={{
                position: "relative",
                top: "50%",
                transform: "translateY(-50%)",
              }}
            >
              More than 150 years of experience in logistics.
            </h1>
            <NavLink to="/Contact">
              <button
                className="back"
                style={{
                  position: "relative",
                  top: "50%",
                  transform: "translateY(-50%)",
                }}
              >
                Learn More
              </button>
            </NavLink>
            <button
              className="close-modal"
              onClick={() => setShowKnowModal(false)}
            >
              ✖
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default FastNavigator;
